import React, { Component } from 'react';
import { Form, Input, Button, Divider, Space } from 'antd';

const FormItem = Form.Item;

class DetailedScheduleEditCommentForm extends Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            comment: props.editValue,
            labelValue: props.labelValue === "myTourComment" ? "My Tour Comment"
                : props.labelValue === "myDayComment" ? "My Day Comment"
                    : props.labelValue === "myAssignComment" ? "My Assignment Comment" : "Comment",
            maxLength: props.labelValue === "myDayComment" ? 1000 : 8000 // Needs to be updated when assignments is added
        }
    }

    handleSubmit = (e) => {
        this.props.handleComponentEditSubmit(this.state.comment, this.props.labelValue);
    }

    handleKeyPress = (e) => {
        e.preventDefault();
        let inputField = e.target;
        const start = inputField.selectionStart;
        const end = inputField.selectionEnd;
        const currentValue = inputField.value;
        const sanitizedText = e.data.replace(/[^a-zA-Z0-9,:;\-.!@?#%|\/$()&\s\n]/g, "");
        const newValue = currentValue.slice(0, start) + sanitizedText + currentValue.slice(end);
        this.setState({ comment: newValue }, () => { this.formRef.current.setFieldsValue({ commentEdit: newValue }) });

    };

    handleCancel = () => {
        this.props.handleEditCancel();
    }

    handleChange = (e) => {
        if (e.target.value !== this.state.comment) {
            this.setState({ comment: e.target.value });
        }
    }

    handlePaste = (e) => {
        // Prevent default paste behavior


        // Get the pasted text
        const pastedText = e.clipboardData.getData("text");

        // Remove special characters (allow only alphanumeric and spaces)
        const sanitizedText = pastedText.replace(/[^a-zA-Z0-9,:;\-.!@?#%|\/$()&\s\n]/g, "");

        // Insert sanitized text into the TextArea
        const textarea = e.target;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const value = textarea.value;


        e.preventDefault();
        const newText = value.slice(0, start) + sanitizedText + value.slice(end);
        this.setState({ comment: newText }, () => { this.formRef.current.setFieldsValue({ commentEdit: newText }) });
    };



    render() {

        return (
            <Form ref={this.formRef} onFinish={this.handleSubmit} initialValues={{ commentEdit: this.state.comment }}>
                <Form.Item name="commentEdit" label={this.state.labelValue}>

                    <Input.TextArea
                        value={this.state.comment}
                        onBeforeInput={this.handleKeyPress}
                        onChange={this.handleChange}
                        name="commentEdit"
                        allowClear
                        maxLength={this.state.maxLength}
                        rows='5'
                    />

                </Form.Item>

                <Form.Item >
                    <Divider />
                    <Space size={"large"}>
                        <Button color="danger" variant="solid" onClick={this.handleCancel}>Cancel</Button>
                        <Button
                            color="primary" variant="solid"
                            htmlType="submit"
                            disabled={this.props.buttonDisable}
                        >Submit
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        );
    }
}

export default DetailedScheduleEditCommentForm;